import React from "react";
import { ExternalLink, Tv, Play, Film, Sparkles, Popcorn } from "lucide-react";
import { findPlatformInfo, STREAMING_PLATFORMS } from "@/constants/platforms";

/**
 * Official vector logos for streaming platforms
 */
export const PlatformLogo = ({ type, className = "w-4 h-4", name }) => {
  const normType = (type || "").toLowerCase();

  if (normType.includes("netflix")) {
    return (
      <svg viewBox="0 0 24 24" fill="currentColor" className={className} aria-hidden="true">
        <path d="M5.398 0v24c2.873-.398 5.746-.796 8.62-1.194V7.575L18.602 24c1.8-.25 3.599-.5 5.398-.75V0h-5.398v16.425L10.796 0H5.398z" fill="#E50914" />
      </svg>
    );
  }

  if (normType.includes("prime") || normType.includes("amazon")) {
    return (
      <svg viewBox="0 0 24 24" fill="currentColor" className={className} aria-hidden="true">
        <path d="M13.9 14.1c-1.8 1.4-4.4 2.1-6.7 2.1-3.2 0-6.1-1.2-8.3-3.2-.2-.2 0-.5.2-.3 2.4 1.4 5.3 2.2 8.3 2.2 2 0 4.3-.5 6.3-1.6.4-.2.7.4.2.8z" fill="#00A8E1" />
        <path d="M14.9 12.6c-.2-.3-1.4-.1-2 .1-.2 0-.2-.2 0-.3 1.1-.8 2.8-.6 3.1-.2.2.3.2 2-.9 3.1-.2.2-.3.1-.2-.1.5-.7.3-2.1 0-2.6z" fill="#FF9900" />
        <path d="M7.7 2.5h2.8v8.6H7.7V2.5zm4.8 2.8h2.6v5.8h-2.6V5.3zm4.7 1.8h2.6v4h-2.6v-4z" fill="#00A8E1" />
      </svg>
    );
  }

  if (normType.includes("disney")) {
    return (
      <svg viewBox="0 0 24 24" fill="currentColor" className={className} aria-hidden="true">
        <path d="M11.5 5.3c-.6 0-1.1.2-1.6.5-.4-.6-.9-1-1.6-1-1.2 0-2.2 1-2.2 2.2 0 1.2 1 2.2 2.2 2.2.3 0 .6-.1.9-.2.2.9.8 1.7 1.7 2.1-.5.7-.8 1.5-.8 2.4 0 2.2 1.8 4 4 4s4-1.8 4-4c0-2.2-1.8-4-4-4-.4 0-.7.1-1 .2-.2-.8-.8-1.5-1.6-1.9.4-.6.6-1.3.6-2 0-1.4-1.1-2.5-2.6-2.5zm7.8 8.1c-.2 0-.4.1-.5.3-.5 1-1.4 1.7-2.5 2-.2 0-.3.2-.3.4 0 .2.1.3.3.4.1 0 .2 0 .3-.1 1.4-.4 2.5-1.3 3.1-2.5.1-.2 0-.4-.2-.5-.1 0-.1 0-.2 0z" fill="#FFFFFF" />
        <path d="M21 11.5h-1.8V9.7c0-.4-.3-.7-.7-.7s-.7.3-.7.7v1.8H16c-.4 0-.7.3-.7.7s.3.7.7.7h1.8v1.8c0 .4.3.7.7.7s.7-.3.7-.7v-1.8H21c.4 0 .7-.3.7-.7s-.3-.7-.7-.7z" fill="#113CCF" />
      </svg>
    );
  }

  if (normType.includes("max") || normType.includes("hbo")) {
    return (
      <svg viewBox="0 0 24 24" fill="currentColor" className={className} aria-hidden="true">
        <circle cx="12" cy="12" r="10" fill="#002BE7" />
        <path d="M7 8.5h2v7H7v-7zm3 0h2.5l2 3.8 2-3.8H19v7h-2v-4.2l-2 3.7h-1l-2-3.7v4.2h-2v-7z" fill="#FFFFFF" />
      </svg>
    );
  }

  if (normType.includes("apple")) {
    return (
      <svg viewBox="0 0 24 24" fill="currentColor" className={className} aria-hidden="true">
        <path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.81-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M15.97 6.37c.62-.75 1.04-1.8 1.01-2.87-.9.04-1.99.6-2.63 1.35-.57.65-1.07 1.71-.93 2.74 1 .08 1.93-.47 2.55-1.22z" fill="#FFFFFF" />
      </svg>
    );
  }

  if (normType.includes("filmin")) {
    return (
      <svg viewBox="0 0 24 24" fill="currentColor" className={className} aria-hidden="true">
        <rect x="2" y="4" width="20" height="16" rx="4" fill="#00D09C" />
        <path d="M6 7.5h3.5v9H6v-9zm5 0h7v2.5h-4.5v1.2H17v2.3h-3.5V16.5H11v-9z" fill="#050505" />
      </svg>
    );
  }

  if (normType.includes("mubi")) {
    return (
      <svg viewBox="0 0 24 24" fill="currentColor" className={className} aria-hidden="true">
        <circle cx="5" cy="12" r="3" fill="#FFFFFF" />
        <circle cx="12" cy="12" r="3" fill="#FFFFFF" />
        <circle cx="19" cy="12" r="3" fill="#FFFFFF" />
      </svg>
    );
  }

  if (normType.includes("paramount")) {
    return (
      <svg viewBox="0 0 24 24" fill="currentColor" className={className} aria-hidden="true">
        <path d="M12 2L4 18h4.5l1.8-4.2h3.4L15.5 18H20L12 2zm0 6.5l1.6 3.5h-3.2L12 8.5z" fill="#0064FF" />
        <circle cx="6" cy="7" r="1" fill="#FFFFFF" />
        <circle cx="9" cy="4.5" r="1" fill="#FFFFFF" />
        <circle cx="15" cy="4.5" r="1" fill="#FFFFFF" />
        <circle cx="18" cy="7" r="1" fill="#FFFFFF" />
      </svg>
    );
  }

  if (normType.includes("movistar")) {
    return (
      <svg viewBox="0 0 24 24" fill="currentColor" className={className} aria-hidden="true">
        <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 14.5c-2.4 0-4.5-1.6-5.2-3.8-.2-.7.3-1.4 1-1.4h.4c.5 0 .9.3 1.1.8.4 1.2 1.5 2 2.7 2 1.7 0 3-1.3 3-3s-1.3-3-3-3c-.6 0-1.1.2-1.6.5-.4.3-.9.2-1.2-.1-.3-.4-.2-1 .2-1.3.7-.5 1.6-.8 2.6-.8 2.8 0 5 2.2 5 5s-2.2 5.1-5 5.1z" fill="#00A9E0" />
      </svg>
    );
  }

  if (normType.includes("youtube")) {
    return (
      <svg viewBox="0 0 24 24" fill="currentColor" className={className} aria-hidden="true">
        <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z" fill="#FF0000" />
      </svg>
    );
  }

  if (normType.includes("google") || normType.includes("play")) {
    return (
      <svg viewBox="0 0 24 24" fill="currentColor" className={className} aria-hidden="true">
        <path d="M3.6 2.3c-.3.3-.5.8-.5 1.4v16.6c0 .6.2 1.1.5 1.4l9.1-9.7L3.6 2.3z" fill="#00E676" />
        <path d="M16.5 8.3L12.7 12l3.8 3.7 4.3-2.4c1.2-.7 1.2-1.9 0-2.6l-4.3-2.4z" fill="#FFD600" />
        <path d="M12.7 12L3.6 2.3c.4-.2 1-.1 1.6.2l11.3 6.4-3.8 3.1z" fill="#00B0FF" />
        <path d="M3.6 21.7l9.1-9.7 3.8 3.1-11.3 6.4c-.6.3-1.2.4-1.6.2z" fill="#FF3D00" />
      </svg>
    );
  }

  if (normType.includes("skyshowtime") || normType.includes("sky")) {
    return (
      <svg viewBox="0 0 24 24" fill="currentColor" className={className} aria-hidden="true">
        <path d="M12 2L2 8l10 6 10-6-10-6zm0 8.5L5.5 8 12 4.1 18.5 8 12 10.5zM2 12l10 6 10-6v3.5l-10 6-10-6V12z" fill="#8E2DE2" />
      </svg>
    );
  }

  if (normType.includes("pluto")) {
    return (
      <svg viewBox="0 0 24 24" fill="currentColor" className={className} aria-hidden="true">
        <circle cx="12" cy="12" r="10" fill="#FFFF00" />
        <path d="M8 8h3c1.7 0 3 1.3 3 3s-1.3 3-3 3H8V8zm2 4.5h1c.8 0 1.5-.7 1.5-1.5S11.8 9.5 11 9.5h-1v3z" fill="#000000" />
      </svg>
    );
  }

  if (normType.includes("vix")) {
    return (
      <svg viewBox="0 0 24 24" fill="currentColor" className={className} aria-hidden="true">
        <rect x="2" y="4" width="20" height="16" rx="4" fill="#FF5A00" />
        <path d="M6 7.5l2.5 6.5 2.5-6.5h2.2L9.5 16.5H7.7L5 7.5h1zm8 0h2v9h-2v-9zm3 0h2.2l1.6 3.2 1.6-3.2H24l-2.6 4.5 2.7 4.5h-2.2l-1.8-3.4-1.8 3.4H17l2.8-4.5L17 7.5z" fill="#FFFFFF" />
      </svg>
    );
  }

  if (normType.includes("rtve")) {
    return (
      <svg viewBox="0 0 24 24" fill="currentColor" className={className} aria-hidden="true">
        <circle cx="12" cy="12" r="10" fill="#00479E" />
        <path d="M6 9h3c1.1 0 2 .9 2 2 0 .8-.5 1.5-1.2 1.8l1.4 2.2H9.8L8.6 13H7.5v2H6V9zm1.5 3h1.5c.3 0 .5-.2.5-.5s-.2-.5-.5-.5H7.5v1zm7-3h4.5v1.5H16v1.2h2.5v1.3H16v2h-1.5V9z" fill="#FFFFFF" />
      </svg>
    );
  }

  if (normType.includes("atresplayer")) {
    return (
      <svg viewBox="0 0 24 24" fill="currentColor" className={className} aria-hidden="true">
        <path d="M12 2L2 19.5h20L12 2zm0 4.5l6.5 11h-13l6.5-11z" fill="#FA4616" />
      </svg>
    );
  }

  if (normType.includes("fandango") || normType.includes("vudu")) {
    return (
      <svg viewBox="0 0 24 24" fill="currentColor" className={className} aria-hidden="true">
        <rect x="2" y="4" width="20" height="16" rx="4" fill="#FA5000" />
        <path d="M7 8h6v2.5H9.5v2h3V15H7V8zm8 0h2.5v7H15V8z" fill="#FFFFFF" />
      </svg>
    );
  }

  if (normType.includes("plex")) {
    return (
      <svg viewBox="0 0 24 24" fill="currentColor" className={className} aria-hidden="true">
        <path d="M12 2L4 12l8 10h4.5L8.5 12 16.5 2H12z" fill="#E5A00D" />
      </svg>
    );
  }

  if (normType.includes("tubi")) {
    return (
      <svg viewBox="0 0 24 24" fill="currentColor" className={className} aria-hidden="true">
        <rect x="2" y="4" width="20" height="16" rx="4" fill="#FA3200" />
        <path d="M6 8h5v2.5H8.5V16H6V8zm6 0h2.5v5.5c0 1.5 1 2.5 2.5 2.5s2.5-1 2.5-2.5V8h2.5v5.5C22 16.5 19.5 18 17 18s-5-1.5-5-4.5V8z" fill="#FFFFFF" />
      </svg>
    );
  }

  if (normType.includes("hulu")) {
    return (
      <svg viewBox="0 0 24 24" fill="currentColor" className={className} aria-hidden="true">
        <path d="M6 6h3v4.5c.5-.8 1.5-1.2 2.5-1.2 2 0 3.5 1.5 3.5 3.7V18h-3v-4.5c0-1-.6-1.5-1.5-1.5s-1.5.5-1.5 1.5V18H6V6z" fill="#1CE783" />
      </svg>
    );
  }

  if (normType.includes("claro")) {
    return (
      <svg viewBox="0 0 24 24" fill="currentColor" className={className} aria-hidden="true">
        <circle cx="12" cy="12" r="10" fill="#E02B20" />
        <polygon points="9.5,7.5 9.5,16.5 16.5,12" fill="#FFFFFF" />
      </svg>
    );
  }

  // Fallback generic streaming badge icon
  return (
    <Tv className={className} />
  );
};

/**
 * Normalizes platforms from raw movie data, custom admin entries, or TMDB watch providers.
 */
export function extractMoviePlatforms(movie) {
  if (!movie) return [];

  const list = [];
  const seenCanonicalIds = new Set();

  // 1. Direct custom platforms configured by Admin (highest priority)
  if (Array.isArray(movie.platforms) && movie.platforms.length > 0) {
    for (const p of movie.platforms) {
      if (!p) continue;
      const rawName = typeof p === "string" ? p : p.name || p.provider_name || p.id;
      if (!rawName) continue;
      const info = findPlatformInfo(rawName);
      const canonicalId = (info?.id || p.id || rawName).toLowerCase().trim();

      if (!seenCanonicalIds.has(canonicalId)) {
        seenCanonicalIds.add(canonicalId);
        list.push({
          id: canonicalId,
          name: typeof p === "object" && p.name ? p.name : (info?.name || rawName),
          shortName: info?.shortName || (typeof p === "object" && p.name ? p.name : rawName),
          url: p.url || info?.defaultUrl || "",
          logo_url: p.logo_url || null,
          logoType: info?.logoType || canonicalId,
          badgeBg: info?.badgeBg || "bg-zinc-900 hover:bg-zinc-800 text-white border-white/20",
          color: info?.color || "#E11D48",
          type: p.type || "stream"
        });
      }
    }
  }

  // 2. TMDb watch providers format if present (e.g. from /media endpoint or auto-import)
  const wp = movie.watch_providers || movie.watchProviders;
  if (wp) {
    const regionalData = wp.ES || wp.MX || wp.US || wp.AR || wp.CO || wp.CL || Object.values(wp)[0];
    if (regionalData) {
      const providersList = [
        ...(regionalData.flatrate || []).map((x) => ({ ...x, type: "stream" })),
        ...(regionalData.rent || []).map((x) => ({ ...x, type: "rent" })),
        ...(regionalData.buy || []).map((x) => ({ ...x, type: "buy" }))
      ];

      for (const item of providersList) {
        const rawName = item.provider_name || item.name;
        if (!rawName) continue;
        const info = findPlatformInfo(rawName);
        const canonicalId = (info?.id || rawName).toLowerCase().trim();

        if (!seenCanonicalIds.has(canonicalId)) {
          seenCanonicalIds.add(canonicalId);
          list.push({
            id: canonicalId,
            name: info?.name || rawName,
            shortName: info?.shortName || rawName,
            url: regionalData.link || info?.defaultUrl || `https://www.google.com/search?q=ver+${encodeURIComponent(movie.title || "")}+en+${encodeURIComponent(info?.name || rawName)}`,
            logo_url: item.logo_path ? `https://image.tmdb.org/t/p/w185${item.logo_path}` : null,
            logoType: info?.logoType || canonicalId,
            badgeBg: info?.badgeBg || "bg-zinc-900 hover:bg-zinc-800 text-white border-white/20",
            color: info?.color || "#E11D48",
            type: item.type || "stream"
          });
        }
      }
    }
  }

  return list;
}

/**
 * Main StreamingPlatforms Button Strip
 * Renders next to "Ver película / Ver trailer" button.
 */
export const StreamingPlatforms = ({
  movie,
  platforms: explicitPlatforms,
  variant = "inline", // "inline" | "full" | "compact" | "cards"
  className = "",
  showLabel = true,
  maxItems = 6
}) => {
  const platforms = explicitPlatforms || extractMoviePlatforms(movie);

  if (!platforms || platforms.length === 0) {
    return null;
  }

  const displayedPlatforms = maxItems ? platforms.slice(0, maxItems) : platforms;

  if (variant === "inline") {
    return (
      <div className={`flex flex-wrap items-center gap-2 ${className}`} data-testid="streaming-platforms-inline">
        {showLabel && (
          <span className="text-[11px] font-semibold uppercase tracking-wider text-zinc-400 flex items-center gap-1.5 mr-1 shrink-0">
            <Tv size={13} className="text-[#E11D48]" />
            <span className="hidden sm:inline">Disponible en:</span>
            <span className="sm:hidden">Ver en:</span>
          </span>
        )}

        {displayedPlatforms.map((p) => {
          const href = p.url || `https://www.google.com/search?q=ver+${encodeURIComponent(movie?.title || "")}+en+${encodeURIComponent(p.name)}`;

          return (
            <a
              key={p.id}
              href={href}
              target="_blank"
              rel="noopener noreferrer"
              data-testid={`platform-btn-${p.id}`}
              className={`group inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full text-xs font-semibold border transition-all shadow-sm duration-200 active:scale-95 shrink-0 ${p.badgeBg}`}
              title={`Ver ${movie?.title || "película"} oficial en ${p.name}`}
              aria-label={`Ver ${movie?.title || "película"} en ${p.name}`}
            >
              {p.logo_url ? (
                <img
                  src={p.logo_url}
                  alt={p.name}
                  className="w-4 h-4 object-contain rounded-xs shrink-0"
                  onError={(e) => {
                    e.currentTarget.style.display = "none";
                  }}
                />
              ) : (
                <PlatformLogo type={p.logoType || p.id} className="w-3.5 h-3.5 shrink-0" name={p.name} />
              )}
              <span className="font-medium whitespace-nowrap">{p.shortName || p.name}</span>
              <ExternalLink size={11} className="opacity-60 group-hover:opacity-100 group-hover:translate-x-0.5 transition-transform" />
            </a>
          );
        })}
      </div>
    );
  }

  if (variant === "full") {
    return (
      <div className={`mt-6 p-4 sm:p-5 rounded-2xl bg-[#0E0E12] border border-white/10 shadow-lg ${className}`} data-testid="streaming-platforms-full">
        <div className="flex items-center justify-between gap-3 mb-3 border-b border-white/10 pb-3">
          <div className="flex items-center gap-2">
            <div className="w-7 h-7 rounded-lg bg-[#E11D48]/15 border border-[#E11D48]/30 flex items-center justify-center text-[#E11D48]">
              <Tv size={15} />
            </div>
            <div>
              <h4 className="text-sm font-bold text-white leading-tight">
                Dónde Ver en Streaming Oficial
              </h4>
              <p className="text-[11px] text-zinc-400">
                Plataformas con derechos de reproducción y catálogo disponibles
              </p>
            </div>
          </div>
          <span className="text-[10px] uppercase font-bold tracking-widest text-emerald-400 bg-emerald-500/10 px-2 py-0.5 rounded border border-emerald-500/20">
            {platforms.length} {platforms.length === 1 ? "opción" : "opciones"}
          </span>
        </div>

        <div className="flex flex-wrap gap-2.5 pt-1">
          {displayedPlatforms.map((p) => {
            const href = p.url || `https://www.google.com/search?q=ver+${encodeURIComponent(movie?.title || "")}+en+${encodeURIComponent(p.name)}`;

            return (
              <a
                key={p.id}
                href={href}
                target="_blank"
                rel="noopener noreferrer"
                data-testid={`platform-card-${p.id}`}
                className={`group flex items-center gap-2 px-3.5 py-2 rounded-xl text-xs font-semibold border transition-all shadow-md active:scale-95 ${p.badgeBg}`}
              >
                {p.logo_url ? (
                  <img
                    src={p.logo_url}
                    alt={p.name}
                    className="w-4 h-4 object-contain rounded-xs shrink-0"
                    onError={(e) => {
                      e.currentTarget.style.display = "none";
                    }}
                  />
                ) : (
                  <PlatformLogo type={p.logoType || p.id} className="w-4 h-4 shrink-0" name={p.name} />
                )}
                <div className="flex flex-col text-left">
                  <span className="leading-tight font-bold">{p.name}</span>
                  {p.type && (
                    <span className="text-[9px] opacity-75 font-normal uppercase tracking-wider">
                      {p.type === "stream" ? "Suscripción" : p.type === "rent" ? "Alquiler" : "Compra"}
                    </span>
                  )}
                </div>
                <ExternalLink size={12} className="ml-1 opacity-70 group-hover:opacity-100 group-hover:translate-x-0.5 transition-transform" />
              </a>
            );
          })}
        </div>
      </div>
    );
  }

  // Compact variant (icon badges only)
  return (
    <div className={`flex items-center gap-1.5 flex-wrap ${className}`} data-testid="streaming-platforms-compact">
      {displayedPlatforms.map((p) => {
        const href = p.url || `https://www.google.com/search?q=ver+${encodeURIComponent(movie?.title || "")}+en+${encodeURIComponent(p.name)}`;

        return (
          <a
            key={p.id}
            href={href}
            target="_blank"
            rel="noopener noreferrer"
            title={`Disponible en ${p.name}`}
            aria-label={`Ver en ${p.name}`}
            className="w-7 h-7 rounded-full bg-zinc-900 hover:bg-zinc-800 border border-white/20 flex items-center justify-center p-1.5 transition-all hover:scale-110 shadow-sm"
          >
            {p.logo_url ? (
              <img src={p.logo_url} alt={p.name} className="w-full h-full object-contain" />
            ) : (
              <PlatformLogo type={p.logoType || p.id} className="w-full h-full" name={p.name} />
            )}
          </a>
        );
      })}
    </div>
  );
};
